import { ColumnDef } from "@tanstack/react-table";

import { Appointment, VisitType, visitTypeLabels } from "~/services";
import { CompactTable } from "~/ui/table/CompactTable";
import { VisitHistoryDateCell } from "./VisitHistoryDateCell";

const columns: ColumnDef<Appointment>[] = [
  {
    header: "Date/Time",
    accessorKey: "date",
    cell: ({ row }) => <VisitHistoryDateCell visit={row.original} />,
  },
  {
    header: "Clinician",
    accessorKey: "providerName",
    cell: ({ row }) => {
      const providerName = row.original.provider.name;
      const providerTitle = row.original.provider.title;
      return providerTitle ? `${providerName}, ${providerTitle}` : providerName;
    },
  },
  {
    header: "Visit Type",
    accessorKey: "type",
    cell: ({ row }) => {
      const visitType = row.original.type as VisitType;
      return visitTypeLabels[visitType] || visitType;
    },
  },
  {
    header: "Status",
    accessorKey: "status",
    cell: ({ row }) => {
      const status = row.original.status || "-";
      const cancelReason = row.original.cancelReason;

      return (
        <div className="flex flex-col gap-1">
          <div>{status}</div>
          {cancelReason && <div className="italic">{cancelReason}</div>}
        </div>
      );
    },
  },
  {
    header: "Department",
    accessorKey: "department",
  },
];

export const VisitHistoryTable = ({ data }: { data: Appointment[] }) => {
  return (
    <CompactTable
      data={data}
      columns={columns}
      emptyState="No visit history available."
      tdClassName="pb-8"
    />
  );
};
